module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_waso_studio@2x-7ab64e0cf68ee7f19a5ec48c6ea7fe65.webp";